export const defaultBooleanOptions = [
  { code: 'true', titleEnglish: 'Yes', titleFrench: 'Oui', isDeleted: false },
  { code: 'false', titleEnglish: 'No', titleFrench: 'Non', isDeleted: false },
]; 